/* pi-mega-menu.js — Desktop mega menu hover/focus + keyboard support */
(function () {
  const MQ = '(min-width: 990px)';

  function initMegaMenu(nav) {
    const items = nav.querySelectorAll('[data-pi-mega-item]');
    if (!items.length) return;

    let closeTimer = null;

    const closeAll = () => {
      items.forEach((item) => {
        item.dataset.open = 'false';
        const trigger = item.querySelector('[data-pi-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    const openItem = (item) => {
      closeAll();
      item.dataset.open = 'true';
      const trigger = item.querySelector('[data-pi-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-pi-mega-trigger]');
      const panel = item.querySelector('[data-pi-mega-panel]');
      if (!trigger || !panel) return;

      const scheduleClose = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAll, 120);
      };

      const cancelClose = () => {
        clearTimeout(closeTimer);
      };

      item.addEventListener('mouseenter', () => {
        if (!window.matchMedia(MQ).matches) return;
        cancelClose();
        openItem(item);
      });

      item.addEventListener('mouseleave', () => {
        if (!window.matchMedia(MQ).matches) return;
        scheduleClose();
      });

      item.addEventListener('focusin', () => {
        if (!window.matchMedia(MQ).matches) return;
        cancelClose();
        openItem(item);
      });

      item.addEventListener('focusout', (e) => {
        if (!window.matchMedia(MQ).matches) return;
        if (item.contains(e.relatedTarget)) return;
        scheduleClose();
      });

      trigger.addEventListener('keydown', (e) => {
        if (!window.matchMedia(MQ).matches) return;
        if (e.key === 'Escape') {
          closeAll();
          trigger.blur();
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && window.matchMedia(MQ).matches) closeAll();
    });
  }

  function boot() {
    document.querySelectorAll('.pi-header__nav .pi-mega').forEach(initMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
